import React, { PureComponent } from 'react'
import dataProvider, { GET_LIST } from "providers/dataProvider";
import SuggestionsPatientsListComponent
  from 'components/pages/requisitions/SuggestionsPatientsListComponent';

class WidgetSuggestedPatientsContainer extends PureComponent {
  constructor(props) {
    super(props);

    this.timer = null

    this.state = {
      dataLoading: false,
      patientsData: []
    }
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(prevProps.submitData) === JSON.stringify(this.props.submitData)) return;
    const filterData = {};

    this.props.inputsById.forEach(id => {
      if (
        this.props.submitData[id] === '' ||
        this.props.submitData[id] === undefined ||
        Number.isNaN(this.props.submitData[id])
      )
        return false;
      filterData[id] = this.props.submitData[id]
    })

    if (this.timer) {
      clearTimeout(this.timer)
    }

    this.props.handleEditSelectedPatient();

    this.timer = setTimeout(() => {
      this.loadPatients(filterData)
    }, 1000)
  }

  loadPatients = async (filterData) => {
    if (this.props.isNewPatient) return;
    this.setState({
      dataLoading: true
    })

    const hasBothNames = filterData.patientFirstName && filterData.patientLastName &&
      typeof filterData.patientFirstName === 'string' && typeof filterData.patientLastName === 'string' &&
      filterData.patientFirstName.trim() !== '' && filterData.patientLastName.trim() !== '';

    if (hasBothNames) {
      // Make two API calls: one with names as entered, one with names swapped
      const filterDataSwapped = { ...filterData };
      const tempFirst = filterDataSwapped.patientFirstName;
      filterDataSwapped.patientFirstName = filterDataSwapped.patientLastName;
      filterDataSwapped.patientLastName = tempFirst;

      try {
        // We use sequential awaits instead of Promise.all to avoid potential 
        // request cancellation issues in the data provider when multiple 
        // requests for the same resource are fired simultaneously.
        const response1 = await dataProvider(GET_LIST, 'patients', {
          filter: filterData,
          pagination: { perPage: -1 }
        });

        const response2 = await dataProvider(GET_LIST, 'patients', {
          filter: filterDataSwapped,
          pagination: { perPage: -1 }
        });

        const data1 = response1.data || [];
        const data2 = response2.data || [];

        // Combine results and remove duplicates based on patient ID
        const combinedData = [...data1];
        const existingIds = new Set(data1.map(p => p.id));

        data2.forEach(patient => {
          if (!existingIds.has(patient.id)) {
            combinedData.push(patient);
            existingIds.add(patient.id);
          }
        });

        this.setState({
          dataLoading: false,
          patientsData: combinedData
        });
      } catch (error) {
        console.error('Error loading patients:', error);
        this.setState({
          dataLoading: false,
          patientsData: []
        });
      }
    } else {
      // Normal single API call
      dataProvider(GET_LIST, 'patients', { filter: filterData })
        .then(({ data, total }) => {
          this.setState({
            dataLoading: false,
            patientsData: data
          })
        })
        .catch(error => {
          console.error('Error loading patients:', error);
          this.setState({
            dataLoading: false,
            patientsData: []
          });
        });
    }
  }

  render() {
    return (
      <SuggestionsPatientsListComponent
        dataLoading={this.state.dataLoading}
        handleNewPatientCheck={this.props.handleNewPatientCheck}
        handleClickSuggestedPatient={this.props.handleClickSuggestedPatient}
        patientsData={this.state.patientsData}
        isNewPatient={this.props.isNewPatient}
      />
    )
  }
}

export default WidgetSuggestedPatientsContainer;